export default __webpack_public_path__ + "static/media/erica_musgrove.149c64e5.jpeg";